import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer" 

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [drawer, setDrawer] = useState(false);
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!localStorage.getItem("orders")) {
      localStorage.setItem(
        "orders",
        JSON.stringify([
          {
            id: "ORD-1001",
            customer: "John Doe",
            date: "10 Jan 2026",
            total: "₹45,000",
            status: "pending",
            items: ["S2900-24T4S x2"]
          }
        ])
      );
    }
    setOrders(JSON.parse(localStorage.getItem("orders")));
  }, []);

  const filtered = orders.filter(o =>
    o.id.toLowerCase().includes(search.toLowerCase()) ||
    o.customer.toLowerCase().includes(search.toLowerCase())
  );

  const updateOrder = () => {
    const updated = orders.map(o =>
      o.id === selected.id ? { ...o, status } : o
    );
    setOrders(updated);
    localStorage.setItem("orders", JSON.stringify(updated));
    setDrawer(false);
  };

  const deleteOrder = id => {
    if (!window.confirm("Delete order?")) return;
    const updated = orders.filter(o => o.id !== id);
    setOrders(updated);
    localStorage.setItem("orders", JSON.stringify(updated));
    setDrawer(false);
  };

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <div className="dashboard-header">
          <h1>Order Management</h1>
          <input
            placeholder="Search order / customer"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <section className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(o => (
                <tr key={o.id}>
                  <td data-label="Order ID">{o.id}</td>
                  <td data-label="Customer">{o.customer}</td>
                  <td data-label="Date">{o.date}</td>
                  <td data-label="Total">{o.total}</td>
                  <td data-label="Status">
                    <span className={`status ${o.status}`}>{o.status}</span>
                  </td>
                  <td data-label="Action">
                    <button className="icon-btn icon-view" onClick={() => { setSelected(o); setStatus(o.status); setDrawer(true); }}>👁</button>
                    <button className="icon-btn icon-edit" onClick={() => { setSelected(o); setStatus(o.status); setDrawer(true); }}>✏️</button>
                    <button className="icon-btn icon-delete" onClick={() => deleteOrder(o.id)}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {drawer && selected && (
          <div className="drawer open">
            <div className="drawer-content">
              <h2>Order Details</h2>
              <p><b>Order ID:</b> {selected.id}</p>
              <p><b>Customer:</b> {selected.customer}</p>

              <label>Status</label>
              <select value={status} onChange={e => setStatus(e.target.value)}>
                <option>pending</option>
                <option>completed</option>
              </select>

              <div className="drawer-actions">
                <button className="primary" onClick={updateOrder}>Update</button>
                <button className="danger" onClick={() => deleteOrder(selected.id)}>Delete</button>
                <button onClick={() => setDrawer(false)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </main>
      <Footer/>
    </div>
  );
}
